function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useAsyncFn } from 'react-use';
import PaymentMethodForm from '../form/paymentMethodForm/PaymentMethodForm';
import Loading from '../loading/Loading';
import StripeElements from '../stripe/StripeElements';
import Step from '../wizard/Step';
import text from '../../text';
import { client } from '../../utilities/api';
import { isStaff } from '../../utilities/user';
import { ToggleButtonGroup } from 'react-bootstrap';
import Button from '../button/Button';
import AssignedPaymentForm from '../form/assignedPaymentForm/AssignedPaymentForm';
import { PAY_MODE } from '../../constants/order';
import { Formik } from 'formik';
import { assignedPaymentSchema } from '../../validation';
import FormikFormFooter from '../form/FormikFormFooter';
import { isJobPayable } from '../../utilities/job';
import List from '../list/List';
import { formatDate } from '../../utilities/date';
var PaymentMethodStep = function(param) {
    var paymentMethodId = param.paymentMethodId, onPaymentMethodChange = param.onPaymentMethodChange, job = param.job, currentUser = param.currentUser, handleSubmit = param.handleSubmit, handleSelectedPayMode = param.handleSelectedPayMode, userProfileState = param.userProfileState, selectedPayMode = param.selectedPayMode, isAssignedPayment = param.isAssignedPayment, onAddCard = param.onAddCard, nextButtonProps = param.nextButtonProps, isTrialDetailsVisible = param.isTrialDetailsVisible;
    var availablePayModes = [
        {
            label: 'myPaymentDetails',
            mode: PAY_MODE.PAYMENT_METHOD
        },
        {
            label: 'sendToPayer',
            mode: PAY_MODE.ASSIGNED_PAYMENT,
            isEnabled: function() {
                return isJobPayable(job);
            }
        }
    ];
    var _useAsyncFn = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.createPaymentMethodSetup()
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }), []), 2), _useAsyncFn_ = _useAsyncFn[0], value = _useAsyncFn_.value, loading = _useAsyncFn_.loading, createPaymentMethodSetup = _useAsyncFn[1];
    var _useAsyncFn1 = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getTrialMembershipDetails()
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    })), 2), trialMembershipDetailsState = _useAsyncFn1[0], getTrialMembershipDetails = _useAsyncFn1[1];
    useEffect(function() {
        if (!trialMembershipDetailsState.value && isTrialDetailsVisible) {
            getTrialMembershipDetails();
        }
    }, []);
    useEffect(function() {
        if (!isEmpty(currentUser) && !isStaff(currentUser.role) && userProfileState !== 'loading' && !loading) {
            createPaymentMethodSetup();
        }
    }, [
        currentUser
    ]);
    var renderPaymentMethodType = function(type) {
        switch(type){
            case PAY_MODE.ASSIGNED_PAYMENT:
                {
                    return /*#__PURE__*/ React.createElement(AssignedPaymentForm, null);
                }
            case PAY_MODE.PAYMENT_METHOD:
                {
                    return /*#__PURE__*/ React.createElement(PaymentMethodForm, {
                        onAddCard: onAddCard,
                        onPaymentMethodChange: onPaymentMethodChange
                    });
                }
            default:
                return /*#__PURE__*/ React.createElement("div", null);
        }
    };
    var membershipDetails = trialMembershipDetailsState.value;
    return !loading && userProfileState !== 'loading' ? /*#__PURE__*/ React.createElement(Formik, {
        validateOnMount: true,
        isInitialValid: false,
        validationSchema: isAssignedPayment && assignedPaymentSchema,
        initialValues: {
            payerEmail: '',
            payerName: '',
            message: ''
        },
        onSubmit: function(values) {
            return handleSubmit(values);
        }
    }, function(param) {
        var isValid = param.isValid;
        var _nextButtonProps_disabled;
        return /*#__PURE__*/ React.createElement(StripeElements, {
            clientSecret: value
        }, /*#__PURE__*/ React.createElement(Step, null, /*#__PURE__*/ React.createElement(Step.Content, {
            className: "flex-column"
        }, isTrialDetailsVisible && /*#__PURE__*/ React.createElement("div", {
            className: "align-self-start"
        }, !trialMembershipDetailsState.loading && membershipDetails ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h4", null, text('essentialsMembershipTrial')), /*#__PURE__*/ React.createElement(List, {
            isBorderless: true
        }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
            isColonAppended: true,
            description: text('trialStartDate'),
            value: formatDate(membershipDetails === null || membershipDetails === void 0 ? void 0 : membershipDetails.trial_start_at)
        }), /*#__PURE__*/ React.createElement(List.Item, {
            isColonAppended: true,
            description: text('nextChargeDate'),
            value: formatDate(membershipDetails === null || membershipDetails === void 0 ? void 0 : membershipDetails.next_charge_at)
        }), /*#__PURE__*/ React.createElement(List.Item, {
            isColonAppended: true,
            description: text('contractRenewalDate'),
            value: formatDate(membershipDetails === null || membershipDetails === void 0 ? void 0 : membershipDetails.contract_renewal_at)
        }))), /*#__PURE__*/ React.createElement("p", null, text('essentialsMembershipMessage')), /*#__PURE__*/ React.createElement("p", null, text('receiveEmailBeforeTrialExpires'))) : /*#__PURE__*/ React.createElement(Loading, null)), /*#__PURE__*/ React.createElement(ToggleButtonGroup, {
            className: "PaymentMethodButtonGroup",
            name: "paymentType"
        }, availablePayModes.map(function(param, i) {
            var mode = param.mode, label = param.label;
            return /*#__PURE__*/ React.createElement(Button, {
                key: i,
                variant: selectedPayMode === mode ? 'primary' : 'outline-primary',
                checked: selectedPayMode === mode,
                value: mode,
                onClick: handleSelectedPayMode
            }, text(label));
        })), renderPaymentMethodType(selectedPayMode))), /*#__PURE__*/ React.createElement(FormikFormFooter, {
            disabled: ((_nextButtonProps_disabled = nextButtonProps.disabled) !== null && _nextButtonProps_disabled !== void 0 ? _nextButtonProps_disabled : isAssignedPayment) ? !isValid : !paymentMethodId,
            label: nextButtonProps.label
        }));
    }) : /*#__PURE__*/ React.createElement(Loading, null);
};
export default PaymentMethodStep;
